//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cssVars() {
      return {
        '--color': this.blok?.color
          ? this.blok.color
          : this.$store.state.colorMode === 'light'
          ? 'hsl(0, 0%, 80%)'
          : 'hsl(0, 0%, 40%)',
        '--dw': this.blok?.isHorizontal
          ? this.blok?.size
            ? `${this.blok?.size}rem`
            : '100%'
          : '2px',
        '--dh': this.blok?.isHorizontal ? '2px' : '150%',
        '--hide-mobile': this.blok?.hideMobile ? 'none' : 'block',
      };
    },
  },
};
